import styled from 'styled-components';
import { Box, Paragraph } from '@99designs/emu';
import { colors, spaces } from '@99designs/emu/settings';
import { IconTick1, IconX1 } from '@99designs/icons';
import type { ProductFeature } from '../../types';

export type ListProps = {
    features: ProductFeature[];
};

const StyledList = styled.ul`
    list-style-type: none;
    display: flex;
    flex: 1;
    flex-direction: column;
    word-break: break-word;
    row-gap: ${spaces['0.75bu']};
    margin: ${spaces['4bu']} 0 0;
    padding-left: 0;

    hr:last-child {
        display: none;
    }
`;

const ListItem = styled.li`
    display: flex;
    min-height: 60px;
    width: 100%;
`;

const StyledParagraph = styled(Paragraph)`
    padding: 0 0 0 ${spaces['1bu']};
`;

export function List({ features }: ListProps) {
    return (
        <StyledList>
            {features.map((feature, i) =>
                feature.included ? (
                    <ListItem key={i}>
                        <Box>
                            <IconTick1
                                offsetRight
                                color={colors.grey800}
                                aria-label={__placeholder('available')}
                            />
                        </Box>
                        <StyledParagraph>{feature.name}</StyledParagraph>
                    </ListItem>
                ) : (
                    <ListItem key={i}>
                        <Box>
                            <IconX1
                                offsetRight
                                color={colors.grey300}
                                aria-label={__placeholder('unavailable')}
                            />
                        </Box>
                        <StyledParagraph color={colors.grey300}>{feature.name}</StyledParagraph>
                    </ListItem>
                )
            )}
        </StyledList>
    );
}
